import { Component, OnInit } from '@angular/core';
import { IUser } from '../../model/user';
import { Observable, of, pipe, throwError, from } from 'rxjs';
import { UserService } from '../../services/user.service';
import { PageService } from '../../services/page.service';
import { EmployeeService } from '../../services/employee.service';
import * as jquery from 'jquery';
import { find } from 'rxjs/operators';
import { IDBPage } from '../../model/db-page';

declare var $: any;

@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    standalone: false
})
export class ToolbarComponent implements OnInit {
  hrPages: IDBPage[] = [];
  proPages: any = [];
  erisaPages: any = [];
  showErisa: any;

  showEmployees = false;

  constructor(public userSer: UserService,
    private pageSer: PageService,
    private employeeSer: EmployeeService) {
  }

  permissionData: IUser = JSON.parse(localStorage.getItem(('UserData')));

  ngOnInit() {
    this.checkEmployees();
    this.pageSer.getPages('HR').subscribe((pageData: any) => {
      // this.pages = pageData;
      from(pageData).subscribe( (rec: IDBPage) => {
        rec.href = rec.Name.replace(/\s+/g, '').replace(/\&+/g, '');
        this.hrPages.push( rec );
      });

      this.pageSer.getPages('PRO').subscribe( (proPageData: any) => {
        this.proPages = proPageData;

        this.showErisa = (localStorage.getItem('showErisa') === 'yes' ? true : false);
        if (this.showErisa) {
          this.pageSer.getPages('ERISA').subscribe( (erisaData: any ) => {
            this.erisaPages = erisaData;
          });
        }
      });
    });
  }

  selectMe(event: any) {
    $('#custom-nav a').removeClass('selected');
    let obj = event.target;
    if (event.target.outerHTML.substr(0,6) === '< span' || event.target.outerHTML.substr(0,5) === '<span') {
      obj = event.target.parentNode;
    }
    $(obj).addClass('selected');

    const parentDiv = $(event.target).parents('div').first();

    if ($(parentDiv).hasClass('solution')) {
       $('.solution-center').find('a.sub-bbtn').addClass('act');
    } else {
      if ($(parentDiv).hasClass('solution-center')) {
       $('.solution').find('a').addClass('selected');
       $('.solution-center').find('a.sub-bbtn').addClass('act');
      } else {
        $('.solution-center').find('a.sub-bbtn').removeClass('act');
      }
    }

    if ($(parentDiv).hasClass('business')) {
       $('.business-center').find('a.sub-bbtn').addClass('act');
    } else {
      if ($(parentDiv).hasClass('business-center')) {
       $('.business').find('a').addClass('selected');
        $('.business-center').find('a.sub-bbtn').addClass('act');
      } else {
        $('.business-center').find('a.sub-bbtn').removeClass('act');
      }
    }

  }

  // The login payload carries no marketplace fields, so the link is gated on synced data instead.
  checkEmployees() {
    if (!this.userSer.isClient()) {
      return;
    }
    const userData = this.userSer.getUserData();
    const clientId = userData && userData.client ? userData.client.ID : (userData ? userData.ClientID : null);
    if (!clientId) {
      return;
    }
    this.employeeSer.getEmployees(clientId).subscribe((res: any) => {
      const rows = res && res.data ? res.data.length : 0;
      const synced = !!(res && res.sync && res.sync.last_sync_status === 'ok');
      this.showEmployees = rows > 0 || synced;
    }, () => {
      this.showEmployees = false;
    });
  }
}
